import core from '../modules/core';
import store from '@/store/store'
import utils from '@/utils/utils'

export default {
  list(parameters={}) {
    return core.call({
      url: '/api/v1/mypage/prtSurvey/list',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  view(parameters={}) {
    return core.call({
      url: '/api/v1/mypage/prtSurvey/view',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  saveSurvey(parameters={}) {
    return core.call({
      url: '/api/v1/mypage/prtSurvey/saveSurvey',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  getMyEduInfor(parameters={}) {
    return core.call({
      url: '/api/v1/mypage/getMyEduInfor',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  bsnPlnList(parameters={}) {
    return core.call({
      url: '/api/v1/mypage/bsnPln/list',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  headBsnPlnList(parameters={}) {
    return core.call({
      url: '/api/v1/mypage/bsnPln/memberBsnPlnlist',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },

  
  saveBsnPln(parameters={}) {
    return core.call({
      url: '/api/v1/mypage/bsnPln/saveBsnPln',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  bsnPlnInfo(parameters={}) {
    return core.call({
      url: '/api/v1/mypage/bsnPln/bsnPlnInfo',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  bsnPlnMemberInfo(parameters={}) {
    return core.call({
      url: '/api/v1/mypage/bsnPln/bsnPlnMemberInfo',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  
  sttEndInfo(parameters={}) {
    return core.call({
      url: '/api/v1/mypage/bsnPln/sttEndInfo',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },

  bsnPlnExistInfo(parameters={}) {
    return core.call({
      url: '/api/v1/mypage/bsnPln/bsnPlnExistInfo',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  reqBsnPln(parameters={}) {
    return core.call({
      url: '/api/v1/mypage/bsnPln/reqBsnPln',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },

  activityReport(parameters={}) {
    return core.call({
      url: '/api/v1/mypage/activityReport',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  dailyReport(parameters={}) {
    return core.call({
      url: '/api/v1/mypage/dailyReport',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  }
  

  
  
}
